import { ReactNode } from 'react';
import { cn } from '@/lib/utils.ts';

// Shared building blocks for floating bubble menus (table, image, …). Mirrors
// the `toolbar/ToolbarPrimitives.tsx` pattern so every bubble menu shares one
// container, separator and button styling.

export const BubbleBar = ({ children }: { children: ReactNode }) => (
  <div className="flex items-center gap-0.5 rounded-md border border-neutral-200 bg-basic-white p-1 shadow-md">
    {children}
  </div>
);

export const BubbleSep = () => <div className="mx-0.5 h-5 w-px bg-neutral-200" />;

interface BubbleButtonProps {
  onClick: () => void;
  title: string;
  children: ReactNode;
}

// Square icon button (e.g. table ops, delete).
export const BubbleIconButton = ({
  onClick,
  title,
  children,
  danger = false,
}: BubbleButtonProps & { danger?: boolean }) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    className={cn(
      'flex h-8 w-8 items-center justify-center rounded-md transition',
      danger
        ? 'text-error-300 hover:bg-error-100'
        : 'text-neutral-600 hover:bg-neutral-50 hover:text-neutral-900',
    )}
  >
    {children}
  </button>
);

// Text button (e.g. width presets).
export const BubbleTextButton = ({
  onClick,
  title,
  children,
}: BubbleButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    className="rounded-md px-2 py-1 text-sm text-neutral-600 transition hover:bg-neutral-50 hover:text-neutral-900"
  >
    {children}
  </button>
);
